<template>
  <div class="container">
    <h3>{{ $t("message.yourDetails") }}</h3>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="First Name">{{ $t("message.firstName") }}</label>
        <input
          v-validate="'required'"
          id="FirstName"
          v-model="editModel.FirstName"
          @change="$parent.syncFirstName(editModel.FirstName)"
          name="firstName"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("firstName") | inputNameLocale("firstName") }}
        </div>
      </div>
      <div class="form-group col-md-6">
        <label for="Last Name">{{ $t("message.lastName") }}</label>
        <input
          v-validate="'required'"
          id="LastName"
          v-model="editModel.LastName"
          name="lastName"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("lastName") | inputNameLocale("lastName") }}
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="EmailAddress">{{ $t("message.emailAddress") }}</label>
        <ValidationProvider
          name="Email Address"
          mode="lazy"
          rules="email"
          v-slot="{ errors }"
        >
          <input
            id="EmailAddress"
            v-model="editModel.Email"
            disabled
            name="Email Address"
            type="text"
            class="form-control"
            :aria-invalid="errors.length > 0 ? true : false"
          />
          <div class="invalid-feedback">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>
      <div class="form-group col-md-6">
        <label class="required" for="PhoneNumber">{{
          $t("message.phoneNumber")
        }}</label>
        <input
          v-validate="{
            required: true,
            min: 8,
            regex: this.getRegex(),
            max: this.getMax(),
          }"
          id="PhoneNumber"
          v-model="editModel.Phone"
          name="phoneNumber"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MyDetail",
  props: {
    editModel: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters([ "selectedCompany", ]),
  },
  methods: {
    validate() {
      return this.$validator.validateAll();
    },
    getMax() {
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? 10 : 15;
    },
    getRegex() {
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? /04\d{8}/ : /\d/;
    },
  },
};
</script>
